import React, { useState } from "react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import TableComponent from "../TableComponent/TableComponent";
import { useQuery } from "react-query";
import { QK } from "../../base/qk";
import { getScheduleJobNeedAttention } from "../../api/services/scheduling";
import HouseKeepingConfirmModal from "./modals/HouseKeepingConfirmModal";
import { Button } from "@mui/material";
import CancelJobModal from "./modals/CancelJobModal";
import NotFound from "../NotFound/NotFound";

const JobsNeedAttention = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showJobModal, setShowJobModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const jobPerPage = 10;

  const { data: needAttentionJobs, isLoading } = useQuery(
    [QK.needsAttentionJobs, currentPage],
    () => getScheduleJobNeedAttention(currentPage),
    { keepPreviousData: true, enabled: !!currentPage }
  );

  const totalRecords = needAttentionJobs?.count || 0;
  const totalPages = Math.ceil(totalRecords / jobPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleShowJobModal = (jobId) => {
    setSelectedJob(jobId);
    setShowJobModal(true);
  };
  const handleShowCancelModal = (jobId) => {
    setSelectedJob(jobId);
    setShowCancelModal(true);
  };

  const columns = [
    {
      field: "id",
      headerName: "Job ID",
    },
    {
      field: "startDateTime",
      headerName: "Scheduled Start Date Time",
    },
    {
      field: "jobName",
      headerName: "Job Name",
    },
    {
      field: "serviceUser",
      headerName: "Service User",
    },
    {
      field: "employee",
      headerName: "Employee(s)",
    },
    {
      field: "status",
      headerName: "Status",
    },
  ];

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const data =
    needAttentionJobs?.results?.map((job) => ({
      id: job.id,
      startDateTime: formatDateTime(job.scheduled_start),
      jobName: job.visit_name,
      serviceUser: job.client_name,
      status: job.status,
      employee:
        job.assigned_employee_details?.length > 0
          ? job.assigned_employee_details
              .map((emp) => `${emp.first_name} ${emp.last_name}`)
              .join(", ")
          : "—",
    })) || [];

  const actions = [
    {
      element: (row) => (
        <Button
          startIcon={<Cancel />}
          color="error"
          onClick={() => handleShowCancelModal(row.id)}
          variant="outlined"
          size="small"
        >
          Cancel Job
        </Button>
      ),
    },
    {
      element: (row) => (
        <Button
          startIcon={<CheckCircle />}
          color="primary"
          onClick={() => handleShowJobModal(row.id)}
          variant="outlined"
          size="small"
          className="ml-2"
        >
          Complete Job
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      {data.length === 0 ? (
        <NotFound message="No Jobs Need Attention" />
      ) : (
        <TableComponent
          columns={columns}
          data={data}
          actions={actions}
          isLoading={isLoading}
          pagination={{ totalPages, currentPage }}
          onPageChange={handlePageChange}
        />
      )}
      {/* Job Details Modal */}
      {showJobModal && (
        <HouseKeepingConfirmModal
          jobId={selectedJob}
          open={showJobModal}
          handleClose={() => setShowJobModal(false)}
        />
      )}
      {showCancelModal && (
        <CancelJobModal
          open={showCancelModal}
          jobId={selectedJob}
          handleClose={() => setShowCancelModal(false)}
        />
      )}
    </div>
  );
};

export default JobsNeedAttention;
